import React, { useEffect, useRef } from 'react';
import styles from './index.module.css';

const CloseIcon = () => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 256 256'
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path d='M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z' />
  </svg>
);

export default function AppModal({
  title,
  titleId: titleIdProp,
  children,
  footer,
  size = 'default',
  allowClose = true,
  onClose,
  stackFooter = false,
}) {
  const generatedTitleId = useRef(`app-modal-title-${Math.random().toString(36).slice(2, 9)}`);
  const titleId = titleIdProp || generatedTitleId.current;

  useEffect(() => {
    if (!allowClose || typeof onClose !== 'function') return undefined;
    const handleKey = (event) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [allowClose, onClose]);

  const handleBackdropClick = (event) => {
    if (event.target !== event.currentTarget) return;
    if (allowClose && typeof onClose === 'function') onClose();
  };

  const dialogClassName = size === 'wide' ? `${styles.dialog} ${styles.dialog_wide}` : styles.dialog;
  const footerClassName = stackFooter ? `${styles.footer} ${styles.footer_stacked}` : styles.footer;

  return (
    <div
      className={styles.backdrop}
      role='dialog'
      aria-modal='true'
      aria-labelledby={titleId}
      onClick={handleBackdropClick}
    >
      <div className={dialogClassName} onClick={(event) => event.stopPropagation()}>
        <div className={styles.header}>
          <h2 id={titleId} className={styles.title}>
            {title}
          </h2>
          {allowClose && typeof onClose === 'function' && (
            <button type='button' className={styles.close_btn} aria-label='Close' onClick={onClose}>
              <CloseIcon />
            </button>
          )}
        </div>
        <div className={styles.body}>{children}</div>
        {footer && <div className={footerClassName}>{footer}</div>}
      </div>
    </div>
  );
}

export { styles as appModalStyles };
